import CrmPetDiagnosisControllerClass from "./CrmPetDiagnosisController";

let controller = null;

export function CrmPetDiagnosisController() {
  if (!controller) controller = new CrmPetDiagnosisControllerClass();
  return controller;
}
